export default __webpack_public_path__ + "static/media/IMG2203.ad915300.jpg";